import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Template404Component } from './template-component/template-404.component';

const routes: Routes = [{ path: '', component: Template404Component }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class Template404RoutingModule {}
